import './Visual.css';
export var VisualOverlayCSS = '_s5vdxw0-2-0-1';